import React from 'react';
import { AppShell } from '@/components/nav/AppShell';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';
import { LogOut, Mail, Phone, User } from 'lucide-react';
import { AUTH } from '@/constants/testIds';
import { Badge } from '@/components/ui/badge';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const initials = (user?.name || 'U').split(' ').map(s => s[0]).slice(0, 2).join('').toUpperCase();
  return (
    <AppShell title="Profile">
      <div className="space-y-6">
        <div className="flex flex-col items-center text-center gap-3">
          <div className="h-20 w-20 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-2xl font-semibold">{initials}</div>
          <div>
            <div className="font-display text-2xl font-semibold">{user?.name}</div>
            <Badge className="mt-1">{user?.role}</Badge>
          </div>
        </div>
        <Card><CardContent className="p-4 space-y-2 text-sm">
          <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-muted-foreground" />{user?.email}</div>
          {user?.phone && <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-muted-foreground" />{user.phone}</div>}
        </CardContent></Card>
        <Button variant="outline" className="w-full" onClick={logout} data-testid={AUTH.logoutButton}><LogOut className="h-4 w-4 mr-2" />Log out</Button>
      </div>
    </AppShell>
  );
}
